// extracted by mini-css-extract-plugin
module.exports = {"footer":"_-01Zu","buttons":"_2fL2r","buttonLeft":"EuQOs"};